import React, {Component} from "react";
import {Button, Col, Form, Modal, Row} from "react-bootstrap";
import {
  getAllUser,
  getPrivilegeGetAll,
  putInsertAlertProcessDelayDelivery,
  putInsertAlertTaskDelayDelivery,
} from "../../../../services/RequestService";
import DateInput from "../../../../genericComponents/inputs/DateInput";

class ModalJustify extends Component {
  constructor(props) {
    super(props);

    this.state = {
      description: "",
      responsible: "",
      responsibles: [],
      // Datas manuais (só usadas quando o andamento tem a flag manualDeliveryDate).
      // Pré-preenchidas com as datas atuais da tarefa (strings ISO vindas por prop).
      deliveryDate: props.deliveryDate ? new Date(props.deliveryDate) : null,
      alertDate: props.alertDate ? new Date(props.alertDate) : null,
    };
  }

  componentDidMount = () => {
    getPrivilegeGetAll().then((res) => {
      if (res.ok) {
        let privilegeId = null;
        res.data.forEach((item) => {
          if (item.name === "conceder_adiamento_prazo") {
            privilegeId = item.id;
          }
        });
        getAllUser({ privilegeId }).then((res1) => {
          if (res1.ok) {
            this.setState((state) => ({ ...state, responsibles: res1.data }));
          }
        });
      }
    });
  };

  handleInputChange = (e) => {
    e.persist();
    const { name, value } = e.target;
    this.setState((state) => ({ ...state, [name]: value }));
  };

  handleDateChange = (name, value) => {
    this.setState((state) => ({ ...state, [name]: value }));
  };

  submit = () => {
    const { description, responsible, responsibles, deliveryDate, alertDate } =
      this.state;
    const { taskId, processId, manualDeliveryDate } = this.props;
    let userId = null;
    responsibles.forEach((item) => {
      if (item.name === responsible) {
        userId = item.id;
      }
    });
    let data = {
      description,
      userId,
    };
    // Andamento com datas manuais: envia as novas datas junto (formato YYYY-MM-DD,
    // mesmo do fluxo de inserir andamento). O backend aplica direto na tarefa.
    if (manualDeliveryDate) {
      data["deliveryDate"] = deliveryDate
        ? deliveryDate.toISOString().substring(0, 10)
        : null;
      data["alertDate"] = alertDate
        ? alertDate.toISOString().substring(0, 10)
        : null;
    }
    if (taskId !== null && taskId !== undefined) {
      data["taskId"] = taskId;
      putInsertAlertTaskDelayDelivery(data).then((_) => {
        this.props.onHide();
      });
    } else {
      if (processId !== null && processId !== undefined) {
        data["processId"] = processId;
        putInsertAlertProcessDelayDelivery(data).then((_) => {
          this.props.onHide();
        });
      }
    }
  };

  render() {
    const { description, responsible, responsibles, deliveryDate, alertDate } =
      this.state;
    const { show, onHide, taskId, processId, manualDeliveryDate } = this.props;
    const isTask = taskId !== null && taskId !== undefined;
    const showManualDates = Boolean(manualDeliveryDate) && isTask;

    return (
      <Modal show={show} onHide={onHide} size="md" centered backdrop="static">
        <Modal.Header>
          <Modal.Title>
            Justificar adiamento do
            {isTask
              ? " tarefa"
              : processId !== null && processId !== undefined
              ? " processo"
              : null}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Row>
            <Form.Group as={Col}>
              <Form.Label>Justificativa</Form.Label>
              <Form.Control
                as="textarea"
                name="description"
                value={description}
                onChange={this.handleInputChange}
              />
            </Form.Group>
          </Form.Row>
          <Form.Row>
            <Form.Group as={Col}>
              <Form.Label>Responsável</Form.Label>
              <Form.Control
                as="select"
                name="responsible"
                value={responsible}
                onChange={this.handleInputChange}
              >
                <option />
                {responsibles.map((item) => {
                  return <option key={item.id}>{item.name}</option>;
                })}
              </Form.Control>
            </Form.Group>
          </Form.Row>
          {showManualDates && (
            <Form.Row>
              <Form.Group as={Col} xs={12} lg={6}>
                <Form.Label>Alertar em</Form.Label>
                <DateInput
                  name="alertDate"
                  value={alertDate}
                  onChange={this.handleDateChange}
                />
              </Form.Group>
              <Form.Group as={Col} xs={12} lg={6}>
                <Form.Label>Entregar em</Form.Label>
                <DateInput
                  name="deliveryDate"
                  value={deliveryDate}
                  onChange={this.handleDateChange}
                />
              </Form.Group>
            </Form.Row>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Row>
            <Col>
              <Button variant="secondary" onClick={() => this.props.onHide()}>
                Cancelar
              </Button>
            </Col>
            <Col>
              <Button
                variant="primary"
                disabled={
                  description === "" ||
                  responsible === "" ||
                  (showManualDates && (!deliveryDate || !alertDate))
                }
                onClick={this.submit}
              >
                Justificar
              </Button>
            </Col>
          </Row>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default ModalJustify;
